export { Event } from './Event';
export type { EventProps } from './Event';
